import { configureStore } from '@reduxjs/toolkit';

import consignmentReducer from '@/store/slices/consignmentSlice';
import uiReducer from '@/store/slices/uiSlice';
import storageReducer from '@/store/slices/storageSlice';

import { authSlice } from '@/entities/auth';
import { navigationSlice } from '@/entities/navigation';
import { languageSlice, languageListenerMiddleware } from '@/entities/language';

import { baseApi } from '@/shared/api/base';
import { errorMiddleware } from '@/shared/lib/errors/error-middleware';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    consignment: consignmentReducer,
    ui: uiReducer,
    storage: storageReducer,
    auth: authSlice.reducer,
    navigation: navigationSlice.reducer,
    language: languageSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(baseApi.middleware)
      .concat(errorMiddleware)
      .concat(languageListenerMiddleware.middleware)
});

export const setupStore = () => store;
